import React from 'react'
import { Input } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { Col } from 'styled-bootstrap-grid'
import { LoadingOverlay } from '../../../components/Loading/LoadingOverlay'
import { WizardNavigationWrapper, WizardNav, NavProps } from '../../../components/Wizard/WizardNav'
import { CenteredRow, Label } from '../../../components/Page/Layout'
import { Row } from '../../../components/Grid'
import { getHookValidationResult, isValidating, selectedHook } from '../../../features/hook/selectors'
import { HookActions } from '../../../features/hook/actions'

type Props = {
  close?: () => void
} & NavProps

export const AddHookName = ({ close, ...rest }: Props) => {
  const dispatch = useDispatch()
  const hook = useSelector(selectedHook)
  const status = useSelector(getHookValidationResult)
  const loading = useSelector(isValidating)

  const changeHandler = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const hookToValidate = {
      ...hook,
      name: e.target.value
    }
    dispatch(HookActions.updateNewHook(hookToValidate))
    if (hookToValidate.name && hookToValidate.name.length > 2) {
      dispatch(HookActions.startHookValidation(hookToValidate))
    }
  }

  return (
    <LoadingOverlay loading={loading}>
      <div className="mt40">
        <CenteredRow>Inserisci Nome</CenteredRow>
        <Row>
          <Col md={8} mdOffset={2} xs={12} xsOffset={0}>
            <Label>nome Hook</Label>
            <Input placeholder="nome" onChange={changeHandler} value={hook?.name} />
            <span className="error-input">{status && status.message}</span>
          </Col>
        </Row>
        <WizardNavigationWrapper>
          <WizardNav {...rest} previousStep={close} nextDisabled={!status?.isValid} />
        </WizardNavigationWrapper>
      </div>
    </LoadingOverlay>
  )
}
